module.exports = __webpack_public_path__ + "static/mr-concert-performance-07-38d48e2f066221733d964900c194ca94.jpg";